AccessController = App.loadClass 'admin::Angular/AccessController'

class exports.GenerateKeyFieldsController extends AccessController
    constructor: (@scope, @transitions, @data, @http) ->
        super('generate_key_fields', @http)

        @scope.fullpage = true
        @scope.title = 'Generate Key Fields'
        @scope.absolute_errors = true

        @scope.options =
            company: null
            advisor: null
            year: null
            algorithm: null

        @scope.acres = ''
        @scope.samples = ''
        @scope.fields = []

        @scope.years = {}
        @scope.algorithms = {}

        @scope.saveEnabled = false
        @scope.disableSave = @disableSave
        @scope.generate = @generate
        @scope.save = @save
        @scope.delete = @delete

        @loadScopeData @data.getCompanies(), 'companies'
        @loadScopeData @data.getYears(), 'years'
        @loadScopeData @data.getAlgorithms(), 'algorithms'

    disableSave: () =>
        @scope.saveEnabled = false

    generate: (options) =>
        @scope.saveEnabled = false

        @data.buildMatViews options.company.id, options.advisor.id, options.year, options.algorithm
        .then (response) =>
            @setAlert response.data?.status

            @data.generate options.company.id, options.advisor.id, options.year, options.algorithm
            .then (response) =>
                @setAlert response.data?.status

                @scope.acres = response.data?.data?.acres
                @scope.samples = response.data?.data?.samples
                @scope.fields = response.data?.data?.fields
                @scope.saveEnabled = true

    save: (options) =>
        @data.saveKeyFields options.company.id, options.advisor.id, options.year, @scope.fields
        .then (response) =>
            @setAlert response.data?.status

    delete: (options) =>
        @data.deleteKeyFields options.company.id, options.advisor.id, options.year
        .then (response) =>
            @setAlert response.data?.status
